// tslint:disable: indent

import { TaQuestionData, TaAnswerData } from '../ta-shared';

const BASE_URL = 'https://customerexperiencefestival.com/_functions';
const GET_QUESTIONS = 'getContent';
const GET_ANSWERS = 'getAnswers';

export const getTaQuestions = async (retry: boolean = true): Promise<TaQuestionData[] | []> => {
    try {
        const res = await fetch(`${BASE_URL}/${GET_QUESTIONS}`);
        const data = await res.json();
        return data.questions;
    } catch (err) {
        if (retry) {
            return getTaQuestions(false);
        } else {
            alert('something is wrong. please try again later.');
            return [];
        }
    }
};

export const getTaAnswers = async (retry: boolean = true): Promise<TaAnswerData[] | []> => {
    try {
        const res = await fetch(`${BASE_URL}/${GET_ANSWERS}`);
        const data = await res.json();
        return data.answers;
    } catch (err) {
        if (retry) {
            return getTaAnswers(false);
        } else {
            alert('something is wrong. please try again later.');
            return [];
        }
    }
};

export const mapUsersAnswers = (usersAnswers: string[], allAnswers: TaAnswerData[]): any => {
    return usersAnswers.map((answer) => allAnswers.find((record) => record.answer === answer));
};
